const Feedback = {

    // PAGE HEADER
    "feedback": "Feedback",

    // FIELDS
    "object_condition": "Object Condition",
    "staff": "Staff",
    "activity": "Activity",
    "feedback": "Feedback",
    "feedback_code": "Feedback Code",
    "repaired": "Repaired",
    "replaced": "Replaced",

    // LABELS
    "equipment_name": "Equipment Name",
    "new_part_number": "New Part Number",
    "old_part_number": "Old Part Number",
    "km_item_code": "KM Item Code",
    "make": "Make",
    "object": "Object",
    "available_quantity": "Available Quantity",
    "department": "Department",

    // ERROR
    "error_object_condition": "Select Object Condition",
    "error_staff": "Select Staff",
    "error_activity": "Select Activity",
    "error_feedback": "Enter Feedback",
    "error_feedback_code": "Enter Feedback Code",

    // SUCCESS
    "feedback_submitted": "Feedback Submitted Successfully",

    // DETAILS
    "equipment_object_details": "Equipment & Object Details",

    // TOOLTIP
    "feedback_complete": "Feedback Completed",

}

export default Feedback;